// client/plugins/ObsidianLinkPlugin/helper/getSearchInput.ts
var getSearchInput = (view, text) => {
  const texts = getTextBeforeAndAfterInBrackets(view);
  if (!texts)
    return;
  const searchString = `${texts.before}${text}${texts.after}`;
  const parsedSearchString = searchString.split("|")[0];
  if (!parsedSearchString && typeof parsedSearchString !== "string")
    throw new Error("invalid search");
  return parsedSearchString;
};
var hasInputAlreadyPipe = (view) => {
  const texts = getTextBeforeAndAfterInBrackets(view);
  if (!texts)
    return false;
  return texts.before.includes("|") || texts.before.includes("|");
};
var getTextBeforeAndAfterInBrackets = (view) => {
  const { state } = view;
  const { $from, $to } = state.selection;
  if ($from !== $to)
    return;
  const nodeBefore = $from.nodeBefore;
  const nodeAfter = $from.nodeAfter;
  if (nodeBefore?.type.name !== "text" || nodeAfter?.type.name !== "text")
    return;
  if (!nodeBefore.text?.includes("[[") || !nodeAfter.text?.includes("]]"))
    return;
  const textBeforeSplitted = nodeBefore.text.split("[[");
  const textAfterSplitted = nodeAfter.text.split("]]");
  const textBefore = textBeforeSplitted[textBeforeSplitted.length - 1];
  const textAfter = textAfterSplitted[0];
  return {
    before: textBefore ? textBefore : "",
    after: textAfter ? textAfter : ""
  };
};
export {
  getSearchInput,
  getTextBeforeAndAfterInBrackets,
  hasInputAlreadyPipe
};
